import {json, texture} from "p3";
import common from "../common";
import definitions from "../definitions";
import MenuScene from "./MenuScene";

export default class OutroScene extends MenuScene {
    constructor() {
        super("outro");

        this._frameHolder = null;
        this._imageHolder = null;
        this._frame = null;
        this._sequence = [
            {image:"outro_1", text:"", time:4},
            {image:"outro_2", text:"Huzzah! Another heroic quest quested. Heroically. You're welcome mama.", time:7, character_icon:"dialogue_icon_ivandoe"},
            {image:"outro_5", text:"Oh… that's nice dear. A quest you say?", time:7, character_icon:"dialogue_icon_queen_kristine"},
            {image:"outro_3", text:"Why yes of course.. There was that appalling Royal Sock Robbery. But I hunted them down...", time:7, character_icon:"dialogue_icon_ivandoe"},
            {image:"outro_4", text:"Oh yes, the um… socks. Well done, Ivan-dear. My clever little buck.", time:7, character_icon:"dialogue_icon_queen_kristine"},
            {image:"outro_6", text:"QUEST COMPLETE!\nUntil the next time... QUEST ON!!!", time:7, character_icon:"dialogue_icon_ivandoe"}
        ];
        this._sequenceValue = 0;
        this._currentImage = null;
        this._nextButton = null;
        this._currentTime = 0;
        this._skipButton = null;

        this._music = null;
    }

    init() {
        super.init();
    }

    onSceneLoaded() {
        super.onSceneLoaded();

        this._backing = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._backing.tint = 0xf2e4cd;
        this._backing.width = common.STAGE_WIDTH;
        this._backing.height = common.STAGE_HEIGHT;
        this.addChild(this._backing);

        this._frameHolder = new PIXI.Container();
        this._frameHolder.x = common.STAGE_WIDTH / 2;
        this._frameHolder.y = (common.STAGE_HEIGHT / 2) - 60;
        this.addChild(this._frameHolder);

        this._imageHolder = new PIXI.Container();
        this._imageHolder.scale.y = 600 / 512;
        this._frameHolder.addChild(this._imageHolder);

        this._imageHolder.mask = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._imageHolder.mask.tint = 0x000000;
        this._imageHolder.mask.anchor.set(0.5);
        this._imageHolder.mask.width = 1000;
        this._imageHolder.mask.height = 550;
        this._frameHolder.addChild(this._imageHolder.mask);

        this._frame = new PIXI.Container();
        this._frameHolder.addChild(this._frame);
        const left = new PIXI.Sprite(texture('outro_frame_l'));
        left.x = -1;
        left.anchor.set(1, 0.5);
        this._frame.addChild(left);
        const right = new PIXI.Sprite(texture('outro_frame_l'));
        right.x = 1;
        right.anchor.set(1, 0.5);
        right.scale.x = -1;
        this._frame.addChild(right);

        this._nextButton = P3.Button.create(
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_small_out"),
            texture("btn_icon_next"),
        );
        this._nextButton.x = (common.STAGE_WIDTH/2) + (this._imageHolder.mask.width/2);
        this._nextButton.y = (common.STAGE_HEIGHT/2) + (this._imageHolder.mask.height/2);
        this._nextButton.signals.click.add(this.progressSequence, this);
        this.addChild(this._nextButton);

        this._skipButton = P3.Button.create(
            texture("btn_action_medium_out"),
            texture("btn_action_medium_out"),
            texture("btn_action_medium_out"),
            texture("btn_icon_skip_medium"),
        );
        this._skipButton.x = (common.STAGE_WIDTH/2) + (this._imageHolder.mask.width/2);
        this._skipButton.y = (common.STAGE_HEIGHT/2) + (this._imageHolder.mask.height/2);
        this._skipButton.signals.click.add(this._onSkip, this);
        this.addChild(this._skipButton);

        this._text = new PIXI.BitmapText("", {
            fontName: "Alghera Pro",
            fontSize: 46,
            align: "center",
            tint: 0x000000,
            maxWidth: 850 
        });
        this._text.position.set(common.STAGE_WIDTH/2, (common.STAGE_HEIGHT/2) + 255);
        this._text.anchor.set(0.5, 0);
        this.addChild(this._text);

        this._characterIcon = new PIXI.Sprite(texture("dialogue_icon_ivandoe"));
        this._characterIcon.position.set(this._text.x, this._text.y);
        this._characterIcon.visible = false;
        this.addChild(this._characterIcon);

        if (!common.saveData.settings.musicMute) {
            this._introMusic = P3.audio.playSound("music_quest_outro_start");
        }

        this.addImage();

        this.resize();
    }

    addImage(){
        const image = new PIXI.Sprite(texture(this._sequence[this._sequenceValue].image));
        image.anchor.set(0.5);
        this._imageHolder.addChild(image);

        image.position.set(
            ((image.width/2) - (this._imageHolder.mask.width/2)) * (Math.random() > 0.5 ? -1 : 1),
            ((image.height/2) - (this._imageHolder.mask.height/2)) * (Math.random() > 0.5 ? -1 : 1)
        );
        
        image.scale.set(1.1);
        this.addTween(gsap.to(image, 10, {x:image.x*-1, y:image.y*-1, ease:Sine.easeInOut}));
        this.addTween(gsap.to(image.scale, 10, {x:1, y:1, ease:Sine.easeInOut}));

        if (this._currentImage) {
            image.alpha = 0;
            this.addTween(gsap.to(image, 0.5, {alpha:1, onComplete:() => {
                this._imageHolder.removeChild(this._currentImage);
                this._currentImage = image;
            }}));
        } else {
            this._currentImage = image;
        }

        this._nextButton.visible = !(this._sequence[this._sequenceValue].time);
        this._currentTime = 0;

        this._text.text = this._sequence[this._sequenceValue].text;

        if (this._text.textWidth > 0) {
            this._characterIcon.texture = texture(this._sequence[this._sequenceValue].character_icon);
            this._characterIcon.visible = true;
            this._characterIcon.position.set(this._text.x - this._text.textWidth / 2 - 100, this._text.y - 20);
        }
    }

    destroy() {
        this._nextButton.destroy();
        this._skipButton.destroy();
        this.removeAllTweens(true);
        super.destroy();
    }

    resize() {
        super.resize();

        if (this._skipButton) {
            this._skipButton.position.set(
                (common.STAGE_WIDTH + P3.View.width - this._skipButton.width) * 0.5 - 50,
                P3.View.height - this._skipButton.height * 0.5 - 50
            );
        }
    }

    update() {
        super.update();

        if (!!(this._sequence[this._sequenceValue].time) && this._currentTime < this._sequence[this._sequenceValue].time) {
            this._currentTime += window.dt;
            if (this._currentTime >= this._sequence[this._sequenceValue].time) {
                this.progressSequence();
            }
        }

        if(this._introMusic && this._introMusic.howl == null) {
            //console.log('loop');
            this._introMusic = null;
            if (!common.saveData.settings.musicMute) {
                P3.audio.playMusic("music_quest_outro_loop");
            }
        }
    }

    _onSkip() {
        this.signals.next.dispatch();
    }

    progressSequence() {
        if (this._sequenceValue < this._sequence.length-1) {
            this._sequenceValue ++;
            this.addImage();
            if(this._sequenceValue >= this._sequence.length-1){
                P3.audio.stopMusic();
                if (!common.saveData.settings.musicMute) {
                    P3.audio.playSound("music_quest_outro_end");
                }
            }

        } else {
            this.signals.next.dispatch();
        }
    }

}

/**
 * @static
 * @type {OutroScene}
 */
OutroScene.active = null;